import React from "react";

import { FilteredDataTable } from "@/components/elements/DataTable";

import { ConnectionsNotifications } from "./ConnectionNotifications";
import {
  ConnectionData,
  globalFilterFn,
  useConnectionsColumns,
} from "./columns";

const ConnectionsTable = (props: {
  data: ConnectionData[];
  onRowClick: (
    row: ConnectionData,
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
  ) => void;
}) => {
  const columns = useConnectionsColumns();

  return (
    <div className="flex flex-col gap-8">
      <ConnectionsNotifications connections={props.data} />
      <div className="w-full max-w-(--breakpoint-xl)">
        <FilteredDataTable
          data={props.data}
          columns={columns}
          hiddenColumns={["createdAt", "active"]}
          globalFilter={globalFilterFn}
          onRowClick={props.onRowClick}
          searchPlaceholder="Filter connectors..."
        />
      </div>
    </div>
  );
};

export default ConnectionsTable;
